import { render, staticRenderFns } from "./DescricaoDetalhadaProduto.vue?vue&type=template&id=243eff0f&scoped=true"
import script from "./DescricaoDetalhadaProduto.vue?vue&type=script&lang=js"
export * from "./DescricaoDetalhadaProduto.vue?vue&type=script&lang=js"
import style0 from "./DescricaoDetalhadaProduto.vue?vue&type=style&index=0&id=243eff0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243eff0f",
  null
  
)

export default component.exports